import { IJsonQueryPolygon } from '../../../../api-models/common/json_query';
import { createGeoTagsManager } from '../../utils/createGeoTagsManager';

export const geoPolygonsTagsManager = createGeoTagsManager<IJsonQueryPolygon>({
  jsonQueryKey: 'polygon',
  labelGetter: ({ geoValue }) => geoValue.name,
  id: 'geoPolygons',
});
